import axios from 'axios'
import {handleError} from '../handleError'
import {PassRule, Reservation, ReservationGroup, SpecificRule, Visitor} from '../../object'
import {time} from '../../ladmin/utils/time'
// import {LError} from '../../object'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  async getBlackList ({dispatch}, {pagination, searchParam}) {
    let url = '/passApi/object/freeze/report'
    try {
      let res = null
      res = await axios.post(url, {
        ...searchParam,
        page: pagination.page - 1,
        size: pagination.rowsPerPage
      })
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getCenterAreaList ({dispatch}, {pagination, searchParam}) {
    let url = '/passApi/limiting-area/passRecords'
    try {
      let res = null
      res = await axios.post(url, searchParam)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async unFreezeCenterAreaVehicle ({dispatch}, {searchParam}) {
    let url = '/passApi/limiting-area/blacklist'
    try {
      let res = null
      res = await axios.delete(url, { data: searchParam })
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async deleteCenterAreaVehicle ({dispatch}, {searchParam}) {
    let url = '/passApi/limiting-area'
    try {
      let res = null
      res = await axios.delete(url, { data: searchParam })
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async addBlackVehicle ({dispatch}, {plateNumber, searchParam,comment}) {
    let url = '/passApi/object/' + plateNumber + '/freeze/true?comment='+comment
    try {
      let res = null
      res = await axios.post(url, searchParam)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async unFreezeVehicle ({dispatch}, {plateNumber, searchParam}) {
    let url = '/passApi/object/' + plateNumber + '/freeze/false'
    try {
      let res = null
      res = await axios.post(url, searchParam)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async checkPass ({dispatch}, {plate, datetime, cId}) {
    console.log(plate, datetime, cId)
    return dispatch('getDataFromApi', {
      url: '/passApi/pass/getAuthByPlateNumber',
      method: 'post',
      data: {
        'plateNumber': plate,
        'passTime': datetime + ':00',
        'controllerId': cId
      }
    }, {root: true})
  },
  async getVehicles ({dispatch}, {group, pagination, sortStack, search, filter = {}, locate = 'runtime'}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passApi/object/list`,
      pagination,
      sortStack,
      search,
      filter: {...filter, obgrpId: group.id},
      transDict: {
        plate: 'objectId',
        rhdata: 'RHData',
        startDatetime: 'sdtime',
        endDatetime: 'edtime',
      }
    }, {root: true})
    return {
      items: items,
      amount
    }
  },
  async deleteVehicle ({dispatch}, ids) {
    let url = '/passApi/object/'
    try {
      let res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getPassGroupList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passApi/group/list/',
      pagination,
      sortStack,
      search,
      filter: {...filter} || {},
      transDict: {
        rhdata: 'RHData',
      }
    }, {root: true})
    return {
      items,
      amount
    }
  },
  async getAllPassGroupList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passApi/group/info/all',
      pagination,
      sortStack,
      search,
      filter: {...filter} || {},
      transDict: {
        rhdata: 'RHData',
      }
    }, {root: true})
    return {
      items,
      amount
    }
  },
  async setSpecificRule ({dispatch, rootState}, rule) {
    let res = await dispatch('getDataFromApi', {
      url: '/passApi/pass/rule/controller',
      method: 'put',
      data: {
        'passrule': {...rule.toAPI(), ownerId: rule.vehicle.objectId}
      }
    }, {root: true})
    let s = SpecificRule.fromAPI(res, rootState.parkingLot.controllerList)
    if (rule.isStandalone !== undefined) {
      await dispatch('pass/setStandalone', {
        vehicle: s.vehicle,
        value: rule.isStandalone
      }, {root: true})
      s.isStandalone = rule.isStandalone
    }
    return s
  },
  async setPassGroup ({dispatch}, group) {
    let et = group.expirationTime
    // if (isNaN(et)) {
    //   et = time.parse(et).valueOf() + ''
    // }
    et = time.toTimeStamp(et)
    let res = await dispatch('getDataFromApi', {
      url: '/passApi/group/',
      method: 'put',
      data: {
        'id': '',
        'name': group.name,
        'description': group.description,
        'expirationTime': et,
        'priority': group.priority,
        'osdMsgIn': group.ledPromptIn,
        'vcbMsgIn': group.audioPromptIn,
        'osdMsgOut': group.ledPromptOut,
        'vcbMsgOut': group.audioPromptOut
      }
    }, {root: true})
    return ReservationGroup.fromAPI(res)
  },
  async getRegisterVehicles ({dispatch}, {pagination, sortStack, search, filter = {}, locate = 'runtime'}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passApi/check/list`,
      pagination,
      sortStack,
      search,
      filter: {...filter},
      transDict: {
        plate: 'plateNumber',
      }
    }, {root: true})
    let vehicles = []
    for (let i = 0; i < items.length; i++) {
      let vehicle = items[i]
      vehicle.plateNumber = vehicle.vehicle.plateNumber
      vehicle.phone = (vehicle.user&&vehicle.user.mobilePhone)||''
      vehicle.name = (vehicle.user&&vehicle.user.name)||''
      vehicles.push(vehicle)
    }
    return {
      items: vehicles,
      amount
    }
  },
  async addVehicle ({dispatch}, params) {
    let url = '/passApi/object/'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getAllPassRule ({dispatch,rootState}, id) {
    let url = '/passApi/pass/rule/object/' + id
    try {
      let res = await axios.post(url)
      if(res.data.status === 1){
        let controllers = rootState.parkingLot.controllerList
        return {items: res.data.data.map(item => PassRule.fromAPI(item, controllers)),}
      }
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getRules ({dispatch, rootState}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passApi/pass/rule`,
      pagination,
      sortStack,
      search,
      transDict: {
        'startDatetime': 'sdtime',
        'endDatetime': 'edtime',
        'audioPrompt': 'vcbMsgAllowed',
        'ledPrompt': 'osdMsgAllowed',
        'audioPromptIn': 'vcbMsgIn',
        'ledPromptIn': 'osdMsgIn',
        'audioPromptOut': 'vcbMsgOut',
        'ledPromptOut': 'osdMsgOut',
        'ruleType': 'segmentType',
        'groupId': 'ownerId',
        "status": 'RHData'
      },
      filter:filter
    }, {root: true})
    let controllers = rootState.parkingLot.controllerList
    return {items: items.map(item => PassRule.fromAPI(item, controllers)), amount}
  },
  async getStandAloneVehicles({dispatch},{pagination,plate}){
    let url = "/passApi/object/standalones?page="+(pagination.page-1)+"&size="+pagination.rowsPerPage+"&code="+plate
    try {
      let res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async setRule ({dispatch, rootState}, rule) {
    let res = await dispatch('getDataFromApi', {
      url: '/passApi/pass/rule/controller',
      method: 'put',
      data: {
        'passrule': rule.toAPI('object')
      }
    }, {root: true})
    return PassRule.fromAPI(res, rootState.parkingLot.controllerList)
  },
  async getSelfVehicleList ({dispatch, rootState}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passApi/check/list`,
      pagination,
      sortStack,
      search,
      filter:filter
    }, {root: true})
    return {items:items,amount:amount}
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
